import { $get } from '../axios';
import CloudServerApi from '../../../cloudserver/api';
import EchangeShopApi from '../../../cloudserver/api/exchangeShop';

CloudServerApi($get);
EchangeShopApi($get);
// 获取开发者信息
export const getKfzInfo = params => {
  return $get('/creator/', { act: 'get_kfz_info', ...params });
};
// 获取验证码
export const getVercode = params => {
  return $get('/creator/', { act: 'get_vercode', op: 4, ...params });
};
// 验证验证码
export const checkVercode = params => {
  return $get('/creator/', { act: 'auth_vercode', op: 4, ...params });
};
// 获取首页数据
export const getHomeOverview = params => {
  return $get('/creator/', { act: 'get_home_overview', ...params });
};
//获取学院信息
export const getCollege = params => {
  return $get('/pub/college/getRecommendCourse/', { ...params });
};
//获取公告信息
export const getAnnoce = params => {
  return $get('/pub/notice/list/', { ...params });
};
// 获取首页 banner
export const getHomeBanners = params => {
  return $get('/creator/', { act: 'get_banners', ...params });
};
// 密码登录
export const loginWithPwd = params => {
  return $get('/', { act: 'login_pw', ...params });
};
//获取图片验证码
export const getPicCode = params => {
  return $get('/', { act: 'get_icode', ...params });
};
// 验证码登录 - 获取验证码
export const getLoginCode = params => {
  return $get('/', { act: 'login_code', ...params });
};
// 验证码登录 - 校验验证码
export const loginWithCode = params => {
  return $get('/', { act: 'login_code_auth', ...params });
};
// 判断是否在云服白名单
export const isInCloudWhite = params => {
  return $get('/creator/', { act: 'in_cloud_white', ...params });
};
//独立密码二次认证
export const isCertify = params => {
  return $get('/creator/', { act: 'login_second_pwd', ...params });
};
//独立密码设置
export const judgeCertify = params => {
  return $get('/creator/', { act: 'set_second_pwd', ...params });
};
//独立密码修改
export const modCertify = params => {
  return $get('/creator/', { act: 'set_second_pwd', ...params });
};
//独立密码关闭
export const delCertify = params => {
  return $get('/creator/', { act: 'set_second_pwd', ...params });
};
//登录请求二次认证
export const repeatCertify = params => {
  return $get('/creator/', { act: 'status_second_pwd', ...params });
};
